import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

export interface QuestionCartOptionEvent {
  eventType: "changedValue" | "remove" | "moveUp" | "moveDown";
  label: string;
  id: number;
}

@Component({
  selector: "question-card-option",
  templateUrl: "./questions-card-option.component.html",
  styleUrls: ["./questions-card-option.component.scss"],
})
export class QuestionsCardOptionComponent implements OnInit, OnDestroy {
  public questionText: string;
  public readonly hideOrdering: boolean = true;
  @Input() public questionId: number = 0;
  @Input() public isActive: boolean = false;
  @Input("index") public questionIndex: number = 0;
  @Output() public questionOptionEvent: EventEmitter<QuestionCartOptionEvent> =
    new EventEmitter<QuestionCartOptionEvent>();

  @Input()
  public set initialText(value: string) {
    if (!this.questionText && value) {
      this.questionText = value;
    }
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  public removeQuestion() {
    this.questionOptionEvent.emit({
      eventType: "remove",
      label: this.questionText,
      id: this.questionId,
    });
  }

  public updateQuestionText($event: string) {
    this.questionOptionEvent.emit({
      eventType: "changedValue",
      label: $event as string,
      id: this.questionId,
    });
  }

  public moveUp() {
    this.questionOptionEvent.emit({
      eventType: "moveUp",
      label: this.questionText,
      id: this.questionId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-parent-questions-card/question-card-option/questions-card-option.component.ts